module.exports = __webpack_public_path__ + "7084a67aa6ab0fd5a121c5484ea552f6.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/727.png
// module id = 1688
// module chunks = 2